import { render, staticRenderFns } from "./widgetSysVlanTrafTopn.vue?vue&type=template&id=57861f8d&scoped=true&"
import script from "./widgetSysVlanTrafTopn.vue?vue&type=script&lang=js&"
export * from "./widgetSysVlanTrafTopn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57861f8d",
  null
  
)

export default component.exports